import { ComponentChild } from 'preact'

import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { ImageCaption } from '@bonniernews/dn-design-system-web/components/image-caption/image-caption.tsx'

export interface ArticleImageProps extends SharedProps {
  image: ComponentChild
  caption?: string
  author?: string
  imageType?: string
  fullWidth?: boolean
  forcePx?: boolean
}

export const ArticleImage = ({
  image,
  caption = '',
  author = '',
  imageType = '',
  fullWidth,
  forcePx,
  classNames,
  attributes,
}: ArticleImageProps) => {
  const componentClassName = 'ds-article-image'
  const classes = formatClassString([componentClassName, forcePx && 'ds-force-px', classNames])
  const showCaption = !!caption || !!author

  return (
    <figure className={classes} {...attributes}>
      {fullWidth ? <div className='ds-full-width-element'>{image}</div> : image}
      {showCaption && <ImageCaption caption={caption} author={author} imageType={imageType} forcePx={forcePx} />}
    </figure>
  )
}
